import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { FieldValues, Control, useFormState } from 'react-hook-form';
import { DatePicker } from '@/components/common/DatePicker';

interface DateFieldProps {
  control: unknown;
  name: string;
  label: string;
  placeholder: string;
  isMandatory?: boolean;
  disabled?: boolean;
  dayPickerProps?: object;
}

export const DateField = ({
  control,
  name,
  label,
  placeholder,
  isMandatory = false,
  disabled = false,
  dayPickerProps,
}: DateFieldProps) => {
  const { errors } = useFormState();

  const isError = errors[name];

  return (
    <FormField
      control={control as Control<FieldValues>}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>
            {label}{' '}
            {isMandatory && (
              <span
                className={
                  fieldState.error?.message ? 'text-red-500' : 'text-inherit'
                }
              >
                *
              </span>
            )}
          </FormLabel>
          <FormControl>
            <DatePicker
              className={`w-full ${isError ? 'text-red-500' : ''}`}
              selectedDate={field.value}
              onSelectDate={(date) => field.onChange(date)}
              inline
              dateFormat="dd/MM/yyyy"
              placeholder={placeholder}
              buttonText={placeholder}
              disabled={disabled}
              dayPickerProps={dayPickerProps || {}}
            />
          </FormControl>
          <FormMessage className="opacity-70" />
        </FormItem>
      )}
    />
  );
};
